import { render, staticRenderFns } from "./_traderSoftWare.vue?vue&type=template&id=e9472a6e&scoped=true"
import script from "./_traderSoftWare.vue?vue&type=script&lang=js"
export * from "./_traderSoftWare.vue?vue&type=script&lang=js"
import style0 from "./_traderSoftWare.vue?vue&type=style&index=0&id=e9472a6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9472a6e",
  null
  
)

export default component.exports